import React, { useId } from "react";
import Drawer from "@mui/material/Drawer";
import CreateNewProjectForm from "./CreateNewProjectForm";

const ProjectFormDrawer = ({ open, onClose, onProjectCreated, isEdit = false, data }) => {
  const titleId = useId();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      transitionDuration={500}
      ModalProps={{ closeAfterTransition: true }}
      PaperProps={{
        role: "dialog",
        "aria-modal": true,
        "aria-labelledby": titleId,
        sx: { width: { xs: "100%", md: "94%" }, overflow: "hidden" },
        // Portal form submissions must not bubble into the parent RFQ form.
        onSubmit: (event) => event.stopPropagation(),
      }}
    >
      <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-white px-5 py-4">
        <h2 id={titleId} className="text-lg font-semibold text-[#1F2937]">{isEdit ? "View Project" : "Add Project"}</h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg px-3 py-2 text-sm font-medium text-[#5B6882] hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-500"
        >
          Close <span aria-hidden="true" className="ml-2">x</span>
        </button>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
        <CreateNewProjectForm
          key={data?._id || "new"}
          fullHeight
          isEdit={isEdit}
          data={data}
          setShowCreateProjectForm={onClose}
          onProjectCreated={onProjectCreated}
        />
      </div>
    </Drawer>
  );
};

export default ProjectFormDrawer;
